// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed8e9c42","396":"3ce243dc","453":"8f203c57","636":"3dc8f6ed","667":"8583a717","857":"4ff1ffd1","977":"ba30455b"}[chunkId] + ".chunk.js";
};